(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discovery-feed"] && !Shopify.designMode) return;
  try {
    
  async function loadDynamicDiscoveryItems() {
    const dynamicRows = document.querySelectorAll('.discovery-section--featured_products[data-dynamic="true"]');
    
    for (const row of dynamicRows) {
      const container = row.querySelector('.product-row-scroll');
      const skeleton = row.querySelector('.js-discovery-skeleton');
      const limit = parseInt(row.dataset.limit) || 8;

      if (skeleton) skeleton.style.display = '';
      if (container) container.style.display = 'none';

      const products = await window.SurpravAPI.getTrendingProducts(limit);

      if (skeleton) skeleton.style.display = 'none';
      if (container) container.style.display = '';

      if (products && products.length > 0) {
        console.log('Loaded dynamic products for discovery feed', products);
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', loadDynamicDiscoveryItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-category-menu"] && !Shopify.designMode) return;
  try {
    
  // Mobile category menu toggle
  document.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.querySelector('[data-category-menu-mobile]');
    if (!mobileMenu) return;

    // Open via Mobile_Nav "Categorieën" button
    const toggleBtns = document.querySelectorAll('[data-mobile-menu-toggle], [data-menu-toggle]');
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
      });
    });

    // Close buttons
    const closeBtns = mobileMenu.querySelectorAll('[data-category-menu-close]');
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });

    // Accordion toggles for subcategories
    const accordionToggles = mobileMenu.querySelectorAll('[data-accordion-toggle]');
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const sublist = toggle.nextElementSibling;
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (sublist) {
          sublist.hidden = expanded;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav-sticky"]) return;
  try {
    
  class MobileNavSticky extends HTMLElement {
    constructor() {
      super();
      
      this.triggers = this.querySelectorAll('.mobile-nav__trigger');
      this.init();
      this.initCartCount();
    }
    
    init() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const targetId = trigger.dataset.target;
          const panel = document.getElementById(targetId);
          
          if (panel) {
            this.openPanel(panel);
          }
        });
      });
    }
    
    openPanel(panel) {
      const backdrop = panel.querySelector('.mobile-panel__backdrop');
      const closeBtn = panel.querySelector('.mobile-panel__close');
      
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      
      const closePanel = () => {
        panel.hidden = true;
        document.body.style.overflow = '';
      };
      
      backdrop.addEventListener('click', closePanel);
      closeBtn.addEventListener('click', closePanel);
      
      // Close on Escape
      const handleEscape = (e) => {
        if (e.key === 'Escape' && !panel.hidden) {
          closePanel();
          document.removeEventListener('keydown', handleEscape);
        }
      };
      
      document.addEventListener('keydown', handleEscape);
    }
    
    initCartCount() {
      // Listen to cart updates
      document.addEventListener('cart:updated', (e) => {
        const badge = this.querySelector('[data-cart-count]');
        if (badge && e.detail?.cart) {
          const count = e.detail.cart.item_count;
          
          if (count > 0) {
            badge.textContent = count;
            badge.style.display = 'flex';
          } else {
            badge.style.display = 'none';
          }
        }
      });
    }
  }
  
  if (!customElements.get('mobile-nav-sticky')) {
    customElements.define('mobile-nav-sticky', MobileNavSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"] && !Shopify.designMode) return;
  try {
    
  // Dynamic notification check via App API
  async function checkNotifs() {
    const appUrl = window.__surprav?.appUrl;
    if (!appUrl) return;
    
    try {
      const res = await fetch(`${appUrl}/api/notifs?customerId=${window.__surprav.customerId}`);
      const data = await res.json();
      const badge = document.getElementById('notif-count');
      if (data.count > 0 && badge) {
        badge.style.display = 'flex';
      }
    } catch(e) {}
  }
  
  document.addEventListener('DOMContentLoaded', checkNotifs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surprav-header"] && !Shopify.designMode) return;
  try {
    
  /**
   * Predictive search custom element.
   * Listens for input on the search field, shows a skeleton loader while
   * fetching results via StorefrontAPI.predictiveSearch(), and renders
   * product results or an empty state in the dropdown.
   */
  class PredictiveSearchElement extends HTMLElement {
    constructor() {
      super();
      this._debounceTimer = null;
      this._abortController = null;
      this._isOpen = false;
    }

    connectedCallback() {
      this._input = this.querySelector('input[type="search"]');
      this._resultsContainer = this.querySelector('#predictive-search-results');
      if (!this._input || !this._resultsContainer) return;

      this._input.addEventListener('input', this._onInput.bind(this));
      this._input.addEventListener('focus', this._onFocus.bind(this));
      document.addEventListener('click', this._onClickOutside.bind(this));
      this._input.addEventListener('keydown', this._onKeydown.bind(this));
    }

    disconnectedCallback() {
      clearTimeout(this._debounceTimer);
      document.removeEventListener('click', this._onClickOutside.bind(this));
    }

    _onInput() {
      clearTimeout(this._debounceTimer);
      const query = this._input.value.trim();

      if (query.length < 2) {
        this._close();
        return;
      }

      this._showLoading();
      this._debounceTimer = setTimeout(() => this._fetchResults(query), 300);
    }

    _onFocus() {
      const query = this._input.value.trim();
      if (query.length >= 2 && this._resultsContainer.innerHTML.trim()) {
        this._open();
      }
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        this._close();
        this._input.blur();
      }
    }

    _onClickOutside(e) {
      if (!this.contains(e.target)) {
        this._close();
      }
    }

    _open() {
      this._resultsContainer.classList.add('search-results', 'is-active');
      this._input.setAttribute('aria-expanded', 'true');
      this._isOpen = true;
    }

    _close() {
      this._resultsContainer.classList.remove('is-active');
      this._input.setAttribute('aria-expanded', 'false');
      this._isOpen = false;
    }

    _showLoading() {
      this._resultsContainer.innerHTML =
        '<div class="search-results__loading">' +
          '<div class="skeleton-loader skeleton-loader--text" aria-hidden="true">' +
            '<div class="skeleton-loader__text-block">' +
              '<div class="skeleton-loader__shimmer skeleton-loader__line skeleton-loader__line--wide"></div>' +
              '<div class="skeleton-loader__shimmer skeleton-loader__line skeleton-loader__line--medium"></div>' +
              '<div class="skeleton-loader__shimmer skeleton-loader__line skeleton-loader__line--narrow"></div>' +
            '</div>' +
            '<div class="skeleton-loader__text-block">' +
              '<div class="skeleton-loader__shimmer skeleton-loader__line skeleton-loader__line--wide"></div>' +
              '<div class="skeleton-loader__shimmer skeleton-loader__line skeleton-loader__line--medium"></div>' +
            '</div>' +
          '</div>' +
          '<span class="visually-hidden">Laden…</span>' +
        '</div>';
      this._open();
    }

    async _fetchResults(query) {
      if (this._abortController) {
        this._abortController.abort();
      }
      this._abortController = new AbortController();

      try {
        const api = window.SurpravAPI;
        if (!api || typeof api.predictiveSearch !== 'function') {
          this._renderError();
          return;
        }

        const data = await api.predictiveSearch(query);

        // Check if input changed while we were fetching
        if (this._input.value.trim() !== query) return;

        if (!data || (!data.products?.length && !data.collections?.length)) {
          this._renderEmpty(query);
        } else {
          this._renderResults(data, query);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          this._renderError();
        }
      }
    }

    _renderResults(data, query) {
      const products = data.products || [];
      const count = products.length + (data.collections?.length || 0);

      let html = '<div class="search-results__header">' +
        '<span class="search-results__count">' + count + ' resultaten</span>' +
        '</div><div class="search-results__list" role="listbox">';

      for (const product of products) {
        const price = product.priceRange?.minVariantPrice;
        const formattedPrice = price
          ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: price.currencyCode }).format(price.amount)
          : '';
        const imgUrl = product.featuredImage?.url || '';
        const imgAlt = product.featuredImage?.altText || product.title;

        html += '<a href="/products/' + product.handle + '" class="search-result-item" role="option">' +
          '<div class="search-result-item__image">' +
            (imgUrl
              ? '<img src="' + imgUrl + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '" loading="lazy" width="60" height="60">'
              : '<div class="search-result-item__placeholder"></div>') +
          '</div>' +
          '<div class="search-result-item__details">' +
            '<p class="search-result-item__title">' + this._highlightQuery(product.title, query) + '</p>' +
            '<div class="search-result-item__price">' +
              '<span class="search-result-item__current-price">' + formattedPrice + '</span>' +
            '</div>' +
          '</div>' +
        '</a>';
      }

      html += '</div>';
      html += '<div class="search-results__footer">' +
        '<a href="/search?q=' + encodeURIComponent(query) + '" class="search-results__view-all">Alle resultaten bekijken</a>' +
        '</div>';

      this._resultsContainer.innerHTML = html;
      this._open();
    }

    _renderEmpty(query) {
      const suggestions = ['Trending', 'Bestsellers', 'Nieuw binnen', 'Accessoires'];
      let suggestionsHtml = '';
      for (const s of suggestions) {
        suggestionsHtml += '<a href="/search?q=' + encodeURIComponent(s) + '" class="search-results__suggestion">' + s + '</a> ';
      }

      this._resultsContainer.innerHTML =
        '<div class="search-results__empty">' +
          '<p>Geen resultaten gevonden voor "' + query.replace(/</g, '&lt;').replace(/"/g, '&quot;') + '"</p>' +
          '<p class="search-results__suggestion">Populaire zoekopdrachten: ' + suggestionsHtml + '</p>' +
        '</div>';
      this._open();
    }

    _renderError() {
      this._resultsContainer.innerHTML =
        '<div class="search-results__error">' +
          '<p>Er ging iets mis. Probeer het opnieuw.</p>' +
        '</div>';
      this._open();
    }

    _highlightQuery(text, query) {
      if (!query) return text;
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearchElement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-bar"] && !Shopify.designMode) return;
  try {
    
  // Close utility-bar dropdown when clicking outside
  document.addEventListener('click', function(e) {
    var dropdowns = document.querySelectorAll('.utility-bar__dropdown[open]');
    for (var i = 0; i < dropdowns.length; i++) {
      if (!dropdowns[i].contains(e.target)) {
        dropdowns[i].removeAttribute('open');
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
